<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import IconBox from '@uiKit/components/IconBox.vue'
import type { PiIconName } from '@uiKit/elements/PiIcon.vue'
import StatusPill from './StatusPill.vue'
import type { LifecycleTone } from '../../constants/listingRequestLifecycle'

// The heading every card on the request-detail tabs opens with: a tinted icon,
// the title with one line of context, and an optional status tag on the right.
defineProps<{
  title: string
  subtitle: string
  icon: PiIconName
  /** The heading's id, for the card's `aria-labelledby`. */
  titleId: string
  tag?: { label: string; tone: LifecycleTone } | null
}>()
</script>

<template>
  <Box flex align="center" gap="3" class="card-header">
    <IconBox :icon="icon" size="lg" />
    <Box direction="col" gap="0.125rem" grow class="card-header__titles">
      <Text :id="titleId" is="h2" type="heading" weight="semibold">{{ title }}</Text>
      <Text type="caption">{{ subtitle }}</Text>
    </Box>
    <StatusPill v-if="tag" :label="tag.label" :tone="tag.tone" dot />
  </Box>
</template>

<style scoped>
.card-header {
  flex-wrap: wrap;
  row-gap: 0.5rem;
}

.card-header__titles {
  min-width: 12rem;
}
</style>
